import { render, staticRenderFns } from "./vipGetReportBtn.vue?vue&type=template&id=648f3151&scoped=true&"
import script from "./vipGetReportBtn.vue?vue&type=script&lang=ts&"
export * from "./vipGetReportBtn.vue?vue&type=script&lang=ts&"
import style0 from "./vipGetReportBtn.vue?vue&type=style&index=0&id=648f3151&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648f3151",
  null
  
)

export default component.exports